import { Component, OnInit } from '@angular/core';
import { PusherService, PwaService, Shared } from "@rubii/frontend-common";
import { ConfigService } from "./services/config.service";
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'Rubii - Digital trading platform';
  constructor(private config: ConfigService, private ws: PusherService, private route: ActivatedRoute) {
  }

  forAuth: boolean;

  ngOnInit(): void {
    const currentHost = window.location.hostname.toLowerCase();
    const ssoDomain = Shared.helpers.CookieHelper.getCookie('sso-domain');
    if (ssoDomain && ssoDomain !== currentHost) {
        window.location.href = window.location.href.replace(currentHost, ssoDomain);
        return;
    }

    // Google redirects here after the user connects a Google account from a report (Google Sheet)
    // or a dashboard (Google Slides); hand the result back to the window that opened the sign-in.
    this.route.queryParams.subscribe(params => {
      if (params.state?.match(/\/report\/edit\/|^\/dashboard\/detail\//i) && (params.code || params.error)) {
        this.forAuth = true;
        window.opener.postMessage({...params, redirectUrl: `${location.origin}${location.pathname}`}, '*');
      }
    });
  }

  deactivate() {
    this.ws.clearBind();
  }
}
